import type { DenetimSummary } from "@/api/denetim";
import { t } from "@/i18n";
import { fmtInt } from "@/lib/utils";

function num(v: unknown): number {
  return typeof v === "number" && Number.isFinite(v) ? v : 0;
}

/** summary alanlari `app/audit/catalog.py katalog_denetimi()` `ozet` cikisidir. */
export function DenetimOzet({ summary }: { summary: DenetimSummary }) {
  const eksik = num(summary.eksik_ozellik);
  const rozet = num(summary.rozet_uyusmazlik);
  const gri = num(summary.gri_alan);
  const celiski = num(summary.celiski);

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      <div className={`kpi ${eksik > 0 ? "kpi-warn" : "kpi-ok"}`}>
        <p className="kpi-lbl">{t("denetim.ozet.eksik")}</p>
        <p className="kpi-val mt-2">{fmtInt(eksik)}</p>
      </div>
      <div className={`kpi ${rozet > 0 ? "kpi-warn" : "kpi-ok"}`}>
        <p className="kpi-lbl">{t("denetim.ozet.rozet")}</p>
        <p className="kpi-val mt-2">{fmtInt(rozet)}</p>
      </div>
      <div className={`kpi ${gri > 0 ? "kpi-warn" : "kpi-ok"}`}>
        <p className="kpi-lbl">{t("denetim.ozet.gri")}</p>
        <p className="kpi-val mt-2">{fmtInt(gri)}</p>
      </div>
      <div className={`kpi ${celiski > 0 ? "kpi-warn" : "kpi-ok"}`}>
        <p className="kpi-lbl">{t("denetim.ozet.celiski")}</p>
        <p className="kpi-val mt-2">{fmtInt(celiski)}</p>
      </div>
    </div>
  );
}
